module.exports = __webpack_public_path__ + "img/adaptive-learning.83085336.svg";